import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function SamplesList({ samples }) {
  const { t } = useTranslation();

  // Funzione per tradurre lo stato
  const translateStatus = (status) => {
    if (!status) return '-';

    switch (status.toLowerCase()) {
      case 'sent':
        return t('Inviato');
      case 'draft':
        return t('In Bozza');
      default:
        return status; 
    }
  };

  // Funzione per formattare la data
  const formatDate = (dateString) => {
    if (!dateString) return '-';

    try {
      // Se è già in formato dd-mm-yyyy (varchar), restituiscilo così com'è
      if (dateString.includes('-') && dateString.length === 10) {
        const parts = dateString.split('-');
        // Se è yyyy-mm-dd, convertilo in dd-mm-yyyy
        if (parts[0].length === 4) {
          return `${parts[2]}-${parts[1]}-${parts[0]}`;
        }
        // Se è già dd-mm-yyyy, restituiscilo così
        return dateString;
      }

      // Se è un timestamp (created_at), parsalo e formattalo
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return dateString; // Se non è una data valida, restituisci il valore originale

      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();

      return `${day}-${month}-${year}`;
    } catch (error) {
      return dateString; // In caso di errore, restituisci il valore originale
    }
  };

  return (
    <div className="content_data" id="samples-table">
      <div className="order_table_header">
        <div className="order_table_row">
          <div className="order_table_title sku">{t('order_number')}</div>
          <div className="order_table_title data">{t('date')}</div>
          <div className="order_table_title utente">{t('User')}</div>
          <div className="order_table_title spedizione">{t('common.shipping')}</div>
          <div className="order_table_title consegna">{t('common.reference')}</div>
          <div className="order_table_title articoli">{t('common.total_items')}</div>
          <div className="order_table_title quantita">{t('common.total_qty')}</div>
          <div className="order_table_title actions"></div>
        </div>
      </div>
      <div className="order_table_body">
        {samples.length === 0 ? (
          <div className="no-data">{t('Nessuna campionatura disponibile')}</div>
        ) : (
          samples.map((s, idx) => {
            // Usa l'indirizzo di spedizione completo se disponibile
            const shippingAddress = s?.indirizzo_spedizione_completo ?? s?.shipping_address?.ADDRESS ?? '-';
            const totalItems = s?.numero_prodotti ?? s?.items?.length ?? s?.TotaleArticoli ?? 0;
            const totalQuantity = s?.quantita_articoli ?? s?.TotaleQuantita ?? '-';
            const userName = [s?.NomeCampionatura, s?.CognomeCampionatura].filter(Boolean).join(' ') || s?.business_name || '-';

            return (
              <div key={s?.id ?? idx} className="order_table_row">
                <div className="order_table_column sku" data-label={t('order_number')}>
                  <Link to={`/sample-detail/${s?.OrderIdAX ?? s?.id}`}>
                    {s?.OrderIdAX ?? s?.id ?? '-'}
                  </Link>
                </div>
                <div className="order_table_column data" data-label={t('date')}>
                  {formatDate(s?.DataOrdine ?? s?.created_at)}
                </div>
                <div className="order_table_column utente" data-label={t('User')}>
                  {userName}
                </div>
                <div className="order_table_column spedizione" data-label={t('common.shipping')}>
                  <div className="sub_data">{shippingAddress}</div>
                </div>
                <div className="order_table_column consegna" data-label={t('common.reference')}>
                  <div className="sub_data">{s?.agentName ?? s?.sampling_customer_ref ?? s?.referent ?? '-'}</div>
                </div>
                <div className="order_table_column articoli" data-label={t('common.total_items')}>
                  {totalItems}
                </div>
                <div className="order_table_column quantita" data-label={t('common.total_qty')}>
                  {totalQuantity}
                </div>
                <div className="order_table_column actions">
                </div>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
}